/**
 * Anime.js - easings - ESM
 * @version v4.4.1
 * @license MIT
 * @copyright 2026 - Julian Garnier
 */

/**
 * @import {
 *   EasingFunction,
 * } from '../types/index.js'
*/

/** @type {EasingFunction} */
const none = t => t;

export { none };
